import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body, Query } from '../op-types';

export function createNotificationQueries(client: StoxlyClient) {
  return createQueryKeys('notifications', {
    // ['notifications', 'all', { query }]
    all: (query?: Query<'notificationsList'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.notificationsList({ queries: query, signal }),
    }),

    // ['notifications', 'unreadCount']
    unreadCount: {
      queryKey: null,
      queryFn: ({ signal }) => client.notificationsUnreadCount({ signal }),
    },

    // ['notifications', 'preferences']
    preferences: {
      queryKey: null,
      queryFn: ({ signal }) => client.notificationPreferencesGet({ signal }),
    },

    // ['notifications', 'symbols']
    symbols: {
      queryKey: null,
      queryFn: ({ signal }) => client.notificationSymbolsList({ signal }),
    },
  });
}

export function createNotificationMutations(client: StoxlyClient) {
  return {
    markRead: {
      mutationFn: (id: string) => client.notificationsMarkRead(undefined, { params: { id } }),
    },
    markAllRead: {
      mutationFn: () => client.notificationsMarkAllRead(undefined),
    },
    /** The inbox has been SEEN — clears the bell's badge; marks nothing read. */
    markAllSeen: {
      mutationFn: () => client.notificationsMarkAllSeen(undefined),
    },
    preferencesUpdate: {
      mutationFn: (body: Body<'notificationPreferencesUpdate'>) =>
        client.notificationPreferencesUpdate(body),
    },
    symbolsUpdate: {
      mutationFn: (body: Body<'notificationSymbolsUpdate'>) =>
        client.notificationSymbolsUpdate(body),
    },
    symbolsReplaceAll: {
      mutationFn: (body: Body<'notificationSymbolsReplaceAll'>) =>
        client.notificationSymbolsReplaceAll(body),
    },
  };
}
